import React, { useState } from "react";
import { Plus } from "react-feather";
import { baseurl } from "../../../component/Baseurl";
import axios from "axios";
import Swal from "sweetalert2";

function AddAgent() {
  const [showModal, setShowModal] = useState(false);
  const [formData, setFormData] = useState({
    name: "",
    phone: "",
    email: "",
    // password: "",   
    address: "",
    city: "",
    state: "",
    country: "",
    pincode: "",
    companyName: "",
    flight_markup: "",
    hotel_markup: "",
    bus_markup: "",
    recharge_markup: "",
    pin_qty: "",
    cost_per_pin: "",
    total_amount: ""
  });

  const handleOpenModal = () => setShowModal(true);
  const handleCloseModal = () => setShowModal(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
  
    setFormData((prevData) => {
      const updatedData = {
        ...prevData,
        [name]: value, // Update the input field dynamically
      };
  
      // Calculate total_amount only if both pin_qty and cost_per_pin are entered
      if (updatedData.pin_qty && updatedData.cost_per_pin) {
        updatedData.total_amount = (parseFloat(updatedData.pin_qty) * parseFloat(updatedData.cost_per_pin)).toFixed(2);
      } else {
        updatedData.total_amount = ""; // Reset if either field is empty
      }
  
      return updatedData;
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Validation to check if all required fields are filled
    if (!formData.name || !formData.phone || !formData.email || !formData.address || !formData.city || !formData.state || !formData.country || !formData.pincode) {
      Swal.fire({
        title: "Error!",
        text: "Please fill in all required fields.",
        icon: "error",
        confirmButtonText: "OK"
      });
      return; // Stop form submission if any required field is empty
    }

    console.log("Sent Data:", formData);
    try {
      const response = await axios.post(`${baseurl}addDistributor`, formData);
      console.log("Response:", response.data);
  
      if (response.data.message === "Distributor added successfully") {
        Swal.fire({
          title: "Success!",
          text: "Distributor added successfully!",
          icon: "success",
          confirmButtonText: "OK"
        }).then(() => {
          // Reload the page after successful alert
          window.location.reload();
        });
        setShowModal(false); // Close the modal after success
      } else {
        Swal.fire({
          title: "Error!",
          text: "There was an error adding the agent. Please try again.",
          icon: "error",
          confirmButtonText: "OK"
        });
      }
    } catch (error) {
      console.error("Error:", error);
      Swal.fire({
        title: "Error!",
        text: "Please Fill All the fields..",
        icon: "error",
        confirmButtonText: "OK"
      });
    }
  };
  

  return (
    <>
      {/* Add Agent Button */}
      <span className="btn3" onClick={handleOpenModal}>
        <Plus size={17} /> Create State Head
      </span>

      {/* Modal */}
      {showModal && (
        <div
          className="modal fade show"
          tabIndex="-1"
          style={{ display: "block", background: "rgba(0, 0, 0, 0.5)" }}
          aria-hidden="true"
        >
          <div className="modal-dialog modal-lg">
            <div className="modal-content">
              {/* Modal Header */}
              <div className="modal-header">
                <h5 className="modal-title">Create State Head</h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={handleCloseModal}
                  aria-label="Close"
                ></button>
              </div>

              {/* Modal Body */}
              <div className="modal-body">
                <form onSubmit={handleSubmit}>
                  <div className="row g-1 text-start">
                    <div className="col-md-12">
                      <label className="text-dark mb-1 labelset2 font3">Distributor Name</label>
                      <input
                        type="text"
                        name="name"
                        className="input1"
                        placeholder="Enter name"
                        value={formData.name}
                        onChange={handleChange} required
                      />
                    </div>
                    <div className="col-md-6">
                      <label className="text-dark mb-1 labelset2 font3">Phone</label>
                      <input
                        type="text"
                        name="phone"
                        className="input1"
                        placeholder="Enter phone"
                        value={formData.phone}
                        onChange={handleChange}
                      />
                    </div>
                    <div className="col-md-6">
                      <label className="text-dark mb-1 labelset2 font3">Email</label>
                      <input
                        type="email"
                        name="email"
                        className="input1"
                        placeholder="Enter email"
                        value={formData.email}
                        onChange={handleChange}
                      />
                    </div>
                    {/* <div className="col-md-6">
                      <label className="text-dark mb-1 labelset2 font3">Password</label>
                      <input
                        type="password"
                        name="password"  // Add password field in form
                        className="input1"
                        placeholder="Enter password"
                        value={formData.password}
                        onChange={handleChange}
                      />
                    </div> */}
                    <div className="col-md-12">
                      <label className="text-dark mb-1 labelset2 font3">Address</label>
                      <input
                        type="text"
                        name="address"
                        className="input1"
                        placeholder="Enter address"
                        value={formData.address}
                        onChange={handleChange}
                      />
                    </div>
                    <div className="col-md-4">
                      <label className="text-dark mb-1 labelset2 font3">City</label>
                      <input
                        type="text"
                        name="city"
                        className="input1"
                        placeholder="Enter city"
                        value={formData.city}
                        onChange={handleChange}
                      />
                    </div>
                    <div className="col-md-4">
                      <label className="text-dark mb-1 labelset2 font3">State</label>
                      <input
                        type="text"
                        name="state"
                        className="input1"
                        placeholder="Enter state"
                        value={formData.state}
                        onChange={handleChange}
                      />
                    </div>
                    <div className="col-md-4">
                      <label className="text-dark mb-1 labelset2 font3">Country</label>
                      <input
                        type="text"
                        name="country"
                        className="input1"
                        placeholder="Enter country"
                        value={formData.country}
                        onChange={handleChange}
                      />
                    </div>
                    <div className="col-md-4">
                      <label className="text-dark mb-1 labelset2 font3">Pincode</label>
                      <input
                        type="text"
                        name="pincode"
                        className="input1"
                        placeholder="Enter pincode"
                        value={formData.pincode}
                        onChange={handleChange}
                      />
                    </div>
                    <div className="col-md-8">
                      <label className="text-dark mb-1 labelset2 font3">Company/Business Name (Optional)</label>
                      <input
                        type="text"
                        name="companyName"
                        className="input1"
                        placeholder="Enter company or business name"
                        value={formData.companyName}
                        onChange={handleChange}
                      />
                    </div>





                    <div className="mt-4">
<h2 className="text-dark">Markup Details</h2>
</div>



            <div className="col-md-3">
              <label className="text-dark mb-1 labelset2 font3">Flight Markup</label>
              <input
                type="text"
                name="flight_markup"
                className="input1"
                placeholder="Enter here"
                value={formData.flight_markup || ""}
                onChange={handleChange}
              />
            </div>

            <div className="col-md-3">
              <label className="text-dark mb-1 labelset2 font3">Hotel Markup</label>
              <input
                type="text"
                name="hotel_markup"
                className="input1"
                placeholder="Enter here"
                value={formData.hotel_markup || ""}
                onChange={handleChange}
              />
            </div>

            <div className="col-md-3">
              <label className="text-dark mb-1 labelset2 font3">Bus Markup</label>
              <input
                type="text"
                name="bus_markup"
                className="input1"
                placeholder="Enter here"
                value={formData.bus_markup || ""}
                onChange={handleChange}
              />
            </div>

            <div className="col-md-3">
              <label className="text-dark mb-1 labelset2 font3">Recharge Markup</label>
              <input
                type="text"
                name="recharge_markup"
                className="input1"
                placeholder="Enter here"
                value={formData.recharge_markup || ""}
                onChange={handleChange}
              />
            </div>




            <div className="mt-4">
<h2 className="text-dark">Points / Pins</h2>
</div>


<div className="col-md-3">
      <label className="text-dark mb-1 labelset2 font3">Pin Quantity</label>
      <input
        type="number"
        name="pin_qty"
        className="input1"
        placeholder="Enter here"
        value={formData.pin_qty || ""}
        onChange={handleChange}
      />
    </div>

    <div className="col-md-3">
      <label className="text-dark mb-1 labelset2 font3">Cost Per Pin</label>
      <input
        type="number"
        name="cost_per_pin"
        className="input1"
        placeholder="Enter here"
        value={formData.cost_per_pin || ""}
        onChange={handleChange}
      />
    </div>

    <div className="col-md-3">
      <label className="text-dark mb-1 labelset2 font3">Total Amount</label>
      <input
        type="number"
        name="total_amount"
        className="input1"
        placeholder="Enter here"
        value={formData.total_amount || ""}
        readOnly // Read-only as it is auto-calculated
      />
    </div>

                  </div>




                  

                  <div className="text-end">
                    <button type="submit" className="submit-btn mt-3">
                      Save Changes
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default AddAgent;
